import { useEffect, useRef } from "react";
import { toast } from "react-toastify";

const DEFAULT_MINUTES = 30;

/**
 * Logs the parent out after no user activity for the configured period.
 * Server-side idle is enforced on API; this improves UX when the tab is idle.
 */
export function useParentSessionIdle() {
  const timerRef = useRef(null);

  useEffect(() => {
    const raw = process.env.REACT_APP_PARENT_IDLE_MINUTES;
    const minutes = Math.max(1, parseInt(raw ?? String(DEFAULT_MINUTES), 10) || DEFAULT_MINUTES);
    const ms = minutes * 60 * 1000;

    const clearTimer = () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };

    const schedule = () => {
      clearTimer();
      timerRef.current = setTimeout(() => {
        toast.info("You were logged out due to inactivity.");
        localStorage.clear();
        window.location.href = "/login";
      }, ms);
    };

    const onActivity = () => {
      schedule();
    };

    const events = ["mousedown", "keydown", "scroll", "touchstart", "click"];
    events.forEach((ev) => window.addEventListener(ev, onActivity, { passive: true }));
    schedule();

    return () => {
      events.forEach((ev) => window.removeEventListener(ev, onActivity));
      clearTimer();
    };
  }, []);
}
